import orderBy from "lodash.orderby";
/* Order by trip if any and then by estimate*/

export const sortLoads = (loads: Array<Load.Load>): Array<Load.Load> => {
  const loadsWithoutTrip = orderBy(
    loads.filter(load => !load.trips.length),
    "route.duration"
  );

  for (const load of loads) {
    if (load.trips.length) {
      load.horarioInicioPlanejado = load.trips.sort(
        (a, b) => (a.horarioInicioPlanejado as any) - (b.horarioInicioPlanejado as any)
      )[0].horarioInicioPlanejado;
    }
  }

  const loadsWithTrip = orderBy(
    loads.filter(load => !!load.trips.length),
    "horarioInicioPlanejado"
  );

  return [...loadsWithTrip, ...loadsWithoutTrip];
};
